import { render } from "./EditorControllersDock.vue?vue&type=template&id=14fe2d5d&scoped=true"
import script from "./EditorControllersDock.vue?vue&type=script&lang=js"
export * from "./EditorControllersDock.vue?vue&type=script&lang=js"

import "./EditorControllersDock.vue?vue&type=style&index=0&id=14fe2d5d&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-14fe2d5d"]])

export default __exports__